var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('div',{attrs:{"id":"core-view"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_vm._t("default")],2)],1)]),_c('core-snackbar'),_c('core-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }